module.exports = __webpack_public_path__ + "static/cf-bold-italic-4f27e1553b722a4ee2584b8205a916c2.ttf";